import {
  FETCH_REPORT_HISTORY,
  FETCH_REPORT_HISTORY_FAIL,
  FETCH_REPORT_HISTORY_SUCCESS
} from '../../actions/cm/caseReportHistory';

export const initialState = {
  isLoading: false,
  hasError: false,
  reportHistoryItems: [],
  reportHistoryItemsTotal: 0
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_REPORT_HISTORY:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_REPORT_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        reportHistoryItems: payload.list,
        reportHistoryItemsTotal: payload.total
      };
    case FETCH_REPORT_HISTORY_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        reportHistoryItems: [],
        reportHistoryItemsTotal: 0
      };
    default:
      return state;
  }
}
